var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEndCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928 358.4l-49.066667-49.066667c-172.8-168.533333-586.666667-145.066667-736 0l-49.066666 49.066667c-12.8 12.8-12.8 34.133333 0 49.066667L192 503.466667c12.8 12.8 36.266667 12.8 49.066667 0l108.8-104.533334-8.533334-113.066666c34.133333-34.133333 307.2-34.133333 341.333334 0l-6.4 117.333333 104.533333 100.266667c12.8 12.8 36.266667 12.8 49.066667 0l98.133333-96c14.933333-14.933333 14.933333-36.266667 0-49.066667z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 864L341.333333 661.333333h341.333334z",
    fill: "#B71C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M448 512h128v160h-128z",
    fill: "#B71C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/endCall.8bc87f3f5a8eb85f2028300fc8ae3312.svg";
export { ForwardRef as ReactComponent };